import Division from 'umg-ember-backend/components/record-explorer/for/division';

<template><Division @records={{@model}} @recordType='division' /></template>
